<div class="pagination-container">
  <button class="pagination-button back-button" (click)="showPageClick(0)"
    *ngIf="totalPages > 1 && currentPageIndex > 0">Back to page 1</button>
  <button class="pagination-button" (click)="showPageClick(currentPageIndex -1)"
    *ngIf="showPrevious()">{{"pagination-previous" | translate}}</button>
    <span style="padding-left: 6px">Page {{currentPageIndex+1}} of {{totalPages}}</span>
  <button class="pagination-button" (click)="showPageClick(currentPageIndex + 1)"
  *ngIf="showNext()">{{"pagination-next" | translate}}</button>
</div>
